(function(){
    const videoBackgrounds = document.querySelectorAll('.video_bg');
    if(videoBackgrounds.length==0) return;
    class playerYTClass {
        constructor(playerEl) {
            this.playerEl = playerEl;
            this.player = new YT.Player(this.playerEl, {
                events: {
                    onReady: this.onPlayerReady.bind(this),
                },
            });
            this.event = new CustomEvent("playingYTNow", {
                detail: { player: this.player }, 
            });

            window.addEventListener(
                "playingYTNow",
                this.windowPlayingHandler.bind(this)
            );
        }
        play(){
            this.player.playVideo();
            this.playing = true;
            this.paused = false;
        }
        pause(){
            this.player.pauseVideo();
            this.playing = false;
            this.paused = true;
        }
        onPlayerReady() {
            this.playing = true;
            this.paused = false;
        }

        windowPlayingHandler(e) {
            if (e.detail.player != this.player) {
                this.player.pauseVideo();
            }
        }
    
    
    }

    videoBackgrounds.forEach((videoBackground) => {
        let video;
        let isYT = false
        const yt_player = videoBackground.querySelector(".player.youtube");
        const button = videoBackground.querySelector('.video_bg__play');
        if(yt_player){
            if (typeof YT == "undefined") {
                window.addEventListener('load',()=>{
                    const tag = document.createElement("script");
                    tag.src = "https://www.youtube.com/iframe_api";
                    //const firstScriptTag = document.getElementsByTagName("script")[0];
                    const footer = document.querySelector('.site_footer');
                    footer.after(tag);
                    yt_player.src = yt_player.getAttribute('data-src');
                    window.onYouTubeIframeAPIReady = () => {
                        video = new playerYTClass(
                            yt_player
                        );
                        isYT = true;
                        button.addEventListener('click',()=>{
                            if(video.playing){
                                video.pause();
                                button.classList.remove('playing');
                            }else{
                                video.play();
                                button.classList.add('playing');
                            }
                        });
                        button.classList.add('playing'); 
                    };
                });
                
            } else {
                yt_player.src = yt_player.getAttribute('data-src');
                video = new playerYTClass(
                    yt_player,
                );
                isYT = true;
                button.classList.add('playing');
            }
        }
        else{
            video = videoBackground.querySelector('video');
        }
        if(video){
            if(!isYT){
                const isMobileDevice = window.innerWidth<1200;
                if(isMobileDevice){
                    button.classList.remove('playing');
                    button.style.display = 'none';
                }
                else{
                    const webm = video.dataset.srcWebm;
                    const mp4 = video.dataset.srcMp4;

                    const src1 = document.createElement('source');
                    const src2 = document.createElement('source');

                    src1.src = webm;
                    src1.type = 'video/webm';
                    src2.src = mp4;
                    src2.type = 'video/mp4';

                    video.appendChild(src1);
                    video.appendChild(src2);
                    window.addEventListener('load',()=>{
                        video.muted = true;
                        video.loop = true;
                        if(!isMobileDevice){
                            video.play();
                            button.classList.add('playing');
                        }
                        button.style.display = 'block';
                    });
                    videoBackground.addEventListener('click', () => {
                        if(video.paused){
                            video.play();
                            button.classList.add('playing')
                        }else{
                            video.pause(); 
                            button.classList.remove('playing');
                        }
                    });
                }
            }
            else{
                button.classList.add('playing');
            }
        }
        
    });

    
})();
